import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Ambience from "./components/Ambience";
import Window from "./components/Window";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/ambience" element={<Ambience />} />
        <Route path="/" element={<Ambience />} />
        <Route path="*" element={<Ambience />} />
      </Routes>
    </Router>
  );
}

export default App;
